import { render, staticRenderFns } from "./DossierCaution.vue?vue&type=template&id=1a4fa920&scoped=true&"
import script from "./DossierCaution.js?vue&type=script&lang=js&"
export * from "./DossierCaution.js?vue&type=script&lang=js&"
import style0 from "./DossierCaution.vue?vue&type=style&index=0&id=1a4fa920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4fa920",
  null
  
)

export default component.exports